import React, { Component } from 'react'

import i18n from '../i18n'
import cookie from '../cookie'

import { connect } from 'react-redux'
import Slider from 'react-slick'

import './BandBanner.scss'

class BandBanner extends Component {

    state = {
        currentSlideIndex: 0
    }

    slickRef
    slickChangeTime = Date.now()

    interval
    slickAnimationInterval = () => {
        if (this.slickRef) {
            const now = Date.now()
            if (now - this.slickChangeTime >= (10000 + Math.floor(Math.random() * 10000)) && this.slickRef) {
                this.slickRef.slickNext()
                this.slickChangeTime = now
            }
    
            const els = document.getElementsByClassName('bandbanner-img')
            for (let i=0; i<els.length; i++) {

                if (els && els[0] && els[0].parentElement && els[0].parentElement.parentElement && els[0].parentElement.parentElement.style.width === '0px') {
                    this.slickRef.slickNext()
                    break
                }
            }
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.interval = setInterval(this.slickAnimationInterval, 100)
        }, 2000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    handleClickClose = (e) => {
        e.stopPropagation()
        cookie.SetCookie('hideTopBanner', true, 18 * 60 * 60 * 1000)
        this.forceUpdate()
    }

    handleClickPrvBtn = e => {
        e.stopPropagation()
        this.slickChangeTime = Date.now()
        this.slickRef.slickPrev()
    }

    handleClickNextBtn = e => {
        e.stopPropagation()
        this.slickChangeTime = Date.now()
        this.slickRef.slickNext()
    }

    getBannerImg = () => {
        const { lang } = this.props

        const list = []

        switch (lang) {
            // case 'vi':
            // case 'th':
            // case 'id':
                // 2024-09-27 마케팅팀 요청으로 인한 배너 숨김 처리
                // list.push(...[
                //     {
                //         src: `/images/web/main/banner/${lang}-pricing-down-banner.png`,
                //         handleClick: () => this.props.history.push('/payment')
                //     }
                // ])
                // break

            case 'ko':
                // 2024-09-27 마케팅팀 요청으로 인한 배너 숨김 처리
                // list.push({
                //     src: 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/flitto-top-banner.png',
                //     handleClick: () => window.open('https://heavenly-bull-19f.notion.site/Flitto-068decefcc8c4152b2d44532388c6159')
                // })
                // list.push({
                //     src: 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/cos247-top-banner.jpg',
                //     handleClick: () => window.open('https://www.cos-247.com/')
                // })
                break

            case 'jp':
                break

            case 'en':
            default:
                break
        }
        
        return list
    }

    render () {
        if (cookie.GetCookie('hideTopBanner')) return null
        
        const banners = this.getBannerImg()
        if (banners.length === 0) return null

        const { currentSlideIndex } = this.state
        const slickSetting = {
            infinite: true,
            fade: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: current => this.setState({ currentSlideIndex: current })
        }

        return (
            <>
                <div className='bandbanner-controller' onClick={banners[currentSlideIndex] ? banners[currentSlideIndex].handleClick : null}>
                    <div className='bandbanner-img-wrapper'>
                        {
                            <Slider
                                {...slickSetting}
                                ref={ref => this.slickRef = ref}
                            >
                                {
                                    banners.map(({ src }) => (
                                        <img
                                            className='bandbanner-img'
                                            src={src}
                                            alt='띠배너 이미지'
                                        />
                                    ))
                                }
                            </Slider>
                        }
                    
                    </div>
                    <div className='bandbanner-btn-wrapper'>
                        <div className='bandbanner-open-24Hour-btn' onClick={this.handleClickClose}>
                            <span>{i18n.t('web.bandbanner.close.24hour')}</span>
                            <div className='bandbanner-close-btn'>
                                &#xd7;
                            </div>
                        </div>
                        {
                            banners.length >= 2 &&
                            <>
                                <div className='bandbanner-prev-btn'>
                                    <img src={'https://front.videomonster.com/images-u6yd72dy/web/bandBannerPrvBtn.png'} alt='이전 버튼' onClick={this.handleClickPrvBtn} />
                                </div>
                                <div className='bandbanner-next-btn'>
                                    <img src={'https://front.videomonster.com/images-u6yd72dy/web/bandBannerNextBtn.png'} alt='다음 버튼' onClick={this.handleClickNextBtn} />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang,
    currentUser: state.userStore.user
})

export default connect(mapStateToProps, null)(BandBanner)